import { useCallback } from 'react';
import { Map } from 'immutable';

type SetAllResults = (updater: (prev: Map<string, any>) => Map<string, any>) => void;

/**
 * Shared device link/unlink handlers for the commissioning report modals. All four reports
 * (circuit, controller, comm-loop, cable pre/post-insulation) store the linked device the
 * same way — at info.deviceId in their allResults map — so the link controls are identical.
 *
 * onSelect is an optional side effect to run after a device is linked (cable insulation uses
 * it to fetch the device so its fill-empty effect can prefill info fields).
 */
export function useCommissioningDeviceLink (setAllResults: SetAllResults, onSelect?: (deviceId: string) => void) {
  const handleUnlinkDevice = useCallback(() => {
    setAllResults(prev => prev.setIn(['info', 'deviceId'], null));
  }, [setAllResults]);

  const handleDeviceSelect = useCallback((selectedDeviceId: string) => {
    setAllResults(prev => prev.setIn(['info', 'deviceId'], selectedDeviceId));
    onSelect?.(selectedDeviceId);
  }, [setAllResults, onSelect]);

  return { handleUnlinkDevice, handleDeviceSelect };
}
